var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"w-100 h-100",attrs:{"src":require("@/assets/imgs/404.jpg"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }